import { render, staticRenderFns } from "./TemplatePrenotazioni.vue?vue&type=template&id=518a8ebe&scoped=true&"
import script from "./TemplatePrenotazioni.vue?vue&type=script&lang=js&"
export * from "./TemplatePrenotazioni.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePrenotazioni.vue?vue&type=style&index=0&id=518a8ebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518a8ebe",
  null
  
)

export default component.exports